<div class="list__title">{{ "asset_detail_featured" | translate }}</div>
<div class="list__items">
  @for (tradable of getTradables() | async; track tradable) {
    <div
      class="list__item card-interactive"
      (click)="onClick(tradable)">
      <img
        class="image-size"
        [src]="tradable?.getLogo()"
        (error)="img.src = tradable?.getDefaultLogo()"
        alt="{{ 'logo_alt_text' | translate }}"
        #img />
      <div class="list__item__name">{{ tradable.getName() }}</div>
      <div
        class="list__item__percent"
			[ngClass]="{
				positive: isChangePositive(tradable),
				negative: isChangeNegative(tradable)
			}">
        {{
        getAbsoluteChange(tradable)
        | fiat_precision
        | value_change_prefix
        : {
        isProfit: isChangePositive(tradable),
        noChange: !isChangePositive(tradable) && !isChangeNegative(tradable)
      }
      | percent_symbol
      }}
    </div>
  </div>
}
</div>
